import script from "./fonView.vue?vue&type=script&setup=true&lang=js"
export * from "./fonView.vue?vue&type=script&setup=true&lang=js"

import "./fonView.vue?vue&type=style&index=0&id=e937ad98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e937ad98"]])

export default __exports__